import _ from 'lodash'
import { wrapFnExecOnce } from '../utils/wrap-fn-exec-once'
import { homeDataApi, homeLinksApi } from '../api/home'
import { getExamAreaList } from '../api/common'
import { getAreaApi, collectCatalogApi } from '../api/user'
import { createMaps } from '../utils/create-maps'
import { getLocalItem, setLocalItem } from '../utils/storage'
import { CURRENT_SUBJECT } from '../config'
import {goLoginPage} from '@/utils/go-login-page'

export const getCurrentSubject = () => getLocalItem(CURRENT_SUBJECT)
export const setCurrentSubject = (item) => setLocalItem(CURRENT_SUBJECT, item)
const subjectList = [
  {
    'subjectID': '12',
    'subjectName': '语文',
    'fullName': '高中语文'
  },
  {
    'subjectID': '13',
    'subjectName': '数学',
    'fullName': '高中数学'
  },
  {
    'subjectID': '14',
    'subjectName': '英语',
    'fullName': '高中英语'
  }, {
    'subjectID': '15',
    'subjectName': '物理',
    'fullName': '高中物理'
  },
  {
    'subjectID': '16',
    'subjectName': '化学',
    'fullName': '高中化学'
  }, {
    'subjectID': '17',
    'subjectName': '生物',
    'fullName': '高中生物'
  },
  {
    'subjectID': '18',
    'subjectName': '政治',
    'fullName': '高中政治'
  }, {
    'subjectID': '19',
    'subjectName': '历史',
    'fullName': '高中历史'
  },
  {
    'subjectID': '20',
    'subjectName': '地理',
    'fullName': '高中地理'
  }
]
const subjectIconMaps = {
  12: 'icon-yuwen',
  13: 'icon-shuxue',
  14: 'icon-yingyu',
  15: 'icon-wuli',
  16: 'icon-huaxue',
  17: 'icon-shengwu',
  18: 'icon-zhengzhi',
  19: 'icon-lishi',
  20: 'icon-dili'
}

let state = {
  homeData: {
    counter: {}
  },
  subjectID: '',
  currentSubject: null,
  subjectList: [],
  examAreaList: [],
  province: [],
  friendLinks: [],
  catalogList: [], // 收藏文件夹列表
  getVipDialogVisible: false, // 领取vip
  loginDialogVisible: false,
  loginSuccessHandle: null
}

let getters = {
  topBarCounter (state) {
    return state.homeData.counter
  },
  subjectList (state) {
    return state.subjectList
  },
  currentSubject (state) {
    return state.currentSubject || getLocalItem(CURRENT_SUBJECT) || state.subjectList[0] || {}
  },
  subjectIconMaps (state) {
    return subjectIconMaps // createMaps(state.subjectList)
  },
  subjectNameMaps (state) {
    return createMaps(state.subjectList, 'id', 'fullname')
  },
  subjectMaps (state) {
    return createMaps(state.subjectList, 'id')
  },
  province (state) {
    return state.province
  },
  catalogList (state) {
    return state.catalogList
  },
  catalogNameMap (state) {
    return createMaps(state.catalogList, 'catalogID', 'catalogName')
  }
}

let mutations = {
  saveHomeData (state, data) {
    state.homeData = data
  },
  // 保存学科列表
  saveSubjectList (state, data) {
    state.subjectList = _.map(data, item => {
      return {
        name: item.subjectName,
        id: item.subjectID,
        fullname: item.fullName,
        icon: subjectIconMaps[item.subjectID]
      }
    })
    let subject = getLocalItem(CURRENT_SUBJECT)
    if (!subject) {
      state.currentSubject = state.subjectList[0]
      setCurrentSubject(_.assign({}, state.currentSubject, {_default: true}))
    } else {
      state.currentSubject = subject
    }
  },
  // 更新当前学科
  updateSubject (state, id) {
    let subject
    if (id) {
      subject = _.find(state.subjectList, { id: id })
      state.currentSubject = subject
      setCurrentSubject(subject)
    }
  },
  updateExamAreaList (state, list) {
    state.examAreaList = _.map(list, item => {
      return {
        name: item.areaName,
        id: item.areaID,
        exam: item.exam,
        wl: item.wl
      }
    })
  },
  saveProvince (state, list) {
    state.province = list
  },
  hideLoginDialog (state, cb) {
    state.loginDialogVisible = false
    typeof cb === 'function' && cb()
  },
  goLogin (state, cb) {
    goLoginPage()
    typeof cb === 'function' && cb()
  },
  setGetVipDialogVisible (state, val) {
    state.getVipDialogVisible = val
  },
  saveFriendLinks (state, list) {
    state.friendLinks = list
  },
  saveCatalogList (state, list) {
    state.catalogList = list
  }
}
let actions = {
  getHomeData: wrapFnExecOnce((setState, { state, commit }, payload, cb) => {
    homeDataApi().then((res) => {
      commit('saveHomeData', res.data)
      setState('loaded') // 必须调用 setState 记录状态
    }).catch(() => {
      setState('fail')
    })
  }),
  // 获取基础数据
  getSubjectList: ({ commit }) => {
    commit('saveSubjectList', subjectList)
    commit('basket/initQuesBasket', subjectList, { root: true })
    commit('basket/initPaperCfg', subjectList, { root: true })
    // homeSubjectApi().then((res) => {
    //   console.log(JSON.stringify(res.data))
    //   commit('saveSubjectList', res.data)
    //   commit('basket/initQuesBasket', res.data, { root: true })
    //   commit('basket/initPaperCfg', res.data, { root: true })
    //   setState('loaded') // 必须调用 setState 记录状态
    //   cb && cb()
    // }).catch(() => {
    //   setState('fail')
    // })
  },
  // 获取友情链接
  getFriendLinks: wrapFnExecOnce((setState, { state, commit }, payload, cb) => {
    homeLinksApi({ loading: '1' }).then(({ data }) => {
      commit('saveFriendLinks', data)
      setState('loaded') // 必须调用 setState 记录状态
    }).catch(() => {
      setState('fail')
    })
  }),
  // 获取文件夹列表
  getCatalogList ({ commit }) {
    let subjectID = getLocalItem(CURRENT_SUBJECT).id
    collectCatalogApi({ subjectID }, {silent: '1'}).then(({ data }) => {
      commit('saveCatalogList', data)
    })
  },
  getExamAreaList ({ commit }) {
    return new Promise((resolve, reject) => {
      getExamAreaList().then(res => {
        commit('updateExamAreaList', res.data)
        resolve(res)
      }).catch(res => {
        reject(res)
      })
    })
  },
  // 获取省信息
  getProvinceData: wrapFnExecOnce((setState, { state, commit }, payload, cb) => {
    getAreaApi(payload).then((res) => {
      let data = res.data
      commit('saveProvince', data)
      setState('loaded') // 必须调用 setState 记录状态
    }).catch(() => {
      setState('fail')
    })
  }),
  goLoginPage ({ state, commit }, handle) {
    return new Promise((resolve, reject) => {
      state.loginSuccessHandle = handle
      commit('goLogin', () => {
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
